export const fmt = (n, dp = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp });
};

export const fmtCur = (n, cur = "$", dp = 2) => `${cur}${fmt(n, dp)}`;

export const pct = (n) => `${n >= 0 ? "+" : ""}${fmt(n, 2)}%`;

export const marketLabel = {
  crypto: "Crypto",
  forex: "Forex",
  stocks: "Stocks",
  indices: "Indices",
  commodities: "Commodities",
};

export const biasColor = (b) =>
  b === "bullish" ? "text-bullish" : b === "bearish" ? "text-bearish" : "text-muted-foreground";

export const dirColor = (d) =>
  d?.startsWith("BUY") ? "text-bullish" : d?.startsWith("SELL") ? "text-bearish" : "text-warning";

export const timeAgo = (iso) => {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};
